import { featureRouteOr } from '../helpers';
import { PromotionPages } from '../../constants/AppConstants';

export default featureRouteOr(['enableTPEStaffRover', 'enableStaffDiscounts'], PromotionPages.TOC_FAMILY, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/promotion/TOCFamilyPromotion').default);
        }, 'promotion-toc-family');
    }
});
